import { Popper, Box, Table, TableHead, TableRow, TableCell, TableBody, withStyles, Theme } from "@mui/material"
import styles from './NotificationsModal.module.scss'
import useGetVacanciesLogs from "../../../hooks/vacancies/useGetVacanciesLogs"

interface NotificationModalProps {
  isOpen: boolean
  anchorEl: HTMLElement | null
} 

const NotificationsModal = (props: NotificationModalProps) => {
  const {isOpen, anchorEl} = props

  const {logs} = useGetVacanciesLogs();

  return (
    <Popper open={isOpen} anchorEl={anchorEl} sx={{zIndex: 30}}>
      <Box className={styles.container}>
        <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell align="center" sx={{position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 3, borderRight: '1px solid rgba(0,0,0,.1)'}}>Время</TableCell>
                <TableCell align="center">HH</TableCell>
                <TableCell align="center">SuperJob</TableCell>
                <TableCell align="center">Rabota.ru</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
              {logs?.map(log => (
                <TableRow key={log.timestamp}>
                  <TableCell align="left" sx={{position: 'sticky', left: 0, backgroundColor: 'white', borderRight: '1px solid rgba(0,0,0,.1)'}}>{log.timestamp}</TableCell>
                  <TableCell align="center">{log.hhAmount}</TableCell>
                  <TableCell align="center">{log.superJobAmount}</TableCell>
                  <TableCell align="center">{log.rabotaAmount}</TableCell>
                  </TableRow>
              ))}
            </TableBody>
        </Table>
      </Box>
    </Popper>
  )
}

export default NotificationsModal